// ABOUTME: Grid filter for the without-shipment returns list, styled like the state filter.
// ABOUTME: Toggles paid/free chips; the selected values are sent as an array to the backend.

import { Box, useTheme } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';
import { tokens } from '../../../../../theme';
import { RETURN_FILTER_KEYS } from '../../Filter';

const ReturnPaymentTypeFilter = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const filterKey = RETURN_FILTER_KEYS.PAYMENT.backend_key;
    const dispatch = useDispatch();

    const { index, id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    // Same colours as the row label: green for paid, blue in dark mode / primary in light for free.
    const options = [
        { value: 'paid', labeltext: 'paid', labelcolor: 'green' },
        { value: 'free', labeltext: 'free_return', labelcolor: theme.palette.mode === 'dark' ? 'blue' : 'primary' },
    ];

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentStates = filterObject.filter[filterKey] || [];

            // Selecting both, or none, leaves the list showing paid and free together.
            const updatedStates = currentStates.includes(itemState)
                ? currentStates.filter(state => state !== itemState)
                : [...currentStates, itemState];

            dispatch(updateFilter({ index, id, filterKey, value: updatedStates }));
        }
    };

    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            {options.map((option, index) => {
                return (
                    <Box
                        className={cx({
                            active: filterObject && filterObject.filter?.[filterKey]?.includes(option.value),
                        })}
                        onClick={() => handleStateToggle(option.value)}
                        key={index + option.labeltext}
                        sx={{
                            height:40,
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100]}`,
                            p:0.5,
                            borderRadius:5,
                            display:"flex",
                            alignItems:'center',
                            "&.active " : {
                                background: colors[option.labelcolor][100],
                                border: `1px solid ${colors[option.labelcolor][100]}`,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                background: colors[option.labelcolor][100],
                                color: colors[option.labelcolor][400],
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                fontWeight:500,
                                display:"inline-flex",
                                minWidth:120,
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:4,
                            }}
                        >
                            {t(option.labeltext)}
                        </Box>

                    </Box>
                );
            })}

        </Box>
    );
};

export default ReturnPaymentTypeFilter;
